import { render } from "./substituteTeachers.vue?vue&type=template&id=0049ae92"
import script from "./substituteTeachers.vue?vue&type=script&lang=js"
export * from "./substituteTeachers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__